module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Medium.8fddcf41.woff";